import { render, staticRenderFns } from "./WeekLessons.vue?vue&type=template&id=0699d754&scoped=true&"
import script from "./WeekLessons.vue?vue&type=script&lang=js&"
export * from "./WeekLessons.vue?vue&type=script&lang=js&"
import style0 from "./WeekLessons.vue?vue&type=style&index=0&id=0699d754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699d754",
  null
  
)

export default component.exports